


























































































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import firebase from 'firebase'
import { db } from '../../firebase/init'
import { RequestOffType } from '../../types'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'
import ViewRequestOff from '../../components/requestsOff/ViewRequestOff.vue'
import CardList from '../../components/layout/CardList.vue'

const requestsOff = collection<RequestOffType>('requestsOff')

@Component({
  components: {
    CardList,
    ViewRequestOff,
  },
})

export default class ManageRequestsOff<T extends Vue> extends Mixins(MainMixin) {
  data:any = {
    reason: '',
  }

  expandDialog = false

  expandDate = ''

  tabs = [{ title: 'Calendar', value: 'calendar' }, { title: 'List', value: 'list' }]

  upcomingRequestsOff:RequestOffType[] = []

  previousRequestsOff:RequestOffType[] = []

  visibleRequests:RequestOffType[] = []

  selectedRequest:string|null = null

  activeRequest:RequestOffType|{id:string} = { id: '' }

  loading = false

  selectedOpen = false

  selectedEvent:any = {}

  start = dayjs()

  get activeTab() {
    return this.$store.state.appStore.activeTab
  }

  clickedMore(x:any) {
    // eslint-disable-next-line prefer-destructuring
    this.requestType = this.requestTypes[3].value
    this.EventBus.$emit('switch-tab', 'list')
  }

  @Watch('start')
  updateStartDate(x:any) {
    console.log('updating to new Date: ', x)
    this.bindMonth(x.toDate())
  }

  @Watch('activeTab', { immediate: true })
  newTab(tab:string) {
    console.log('tab is now: ', tab)
    if (tab === 'list') {
      console.log('here')
      this.requestDates = 'View Upcoming'
      this.bindRequests()
    } else this.start = dayjs()
  }

  setToday() {
    this.start = dayjs()
  }

  end = null

  get fStart() {
    return this.start.format('YYYY-MM-DD')
  }

  focus = ''

  resetRequest(newSearch = false) {
    console.log('updaging')
    this.activeRequest = { id: '' }
    this.selectedRequest = null
    if (newSearch) {
      this.bindRequests(this.requestDates === 'View Previous')
    }
  }

  // getUserName:any = this.getUserName
  blackoutOpen = false

  selectedBlackout:string = ''

  showDay(x:any) {
    console.log('x is : ', x)
    const { date } = x
    console.log('date is: ', date)
    this.blackoutOpen = true
    this.selectedBlackout = date
  }

  selectedElement:any = {}

  async blackoutDate(create:boolean) {
    if (!this.selectedBlackout) return false
    this.loading = true
    if (create) {
      await db.doc(`locations/${this.location}`).update({
        blackoutDates: firebase.firestore.FieldValue.arrayUnion(this.selectedBlackout),
      })
    } else {
      await db.doc(`locations/${this.location}`).update({
        blackoutDates: firebase.firestore.FieldValue.arrayRemove(this.selectedBlackout),
      })
    }
    this.loading = false
    this.blackoutOpen = false
    return true
  }

  showEvent(x:any) {
    console.log('x is : ', x)
    const { nativeEvent } = x
    const { event } = x
    if (event.name === 'No R/Os') return false
    const open = () => {
      this.selectedEvent = event
      this.selectedElement = nativeEvent.target
      console.log('selectedEvent : ', this.selectedEvent)
      // eslint-disable-next-line no-return-assign
      setTimeout(() => this.selectedOpen = true, 10)
    }

    if (this.selectedOpen) {
      this.selectedOpen = false
      setTimeout(open, 10)
    } else {
      open()
    }

    return nativeEvent.stopPropagation()
  }

  get events() {
    return this.visibleRequests.map((event:any) => ({
      name: this.getUserName(event.user),
      reason: event.reason,
      start: event.start,
      end: event.end,
      notes: event.notes,
      status: event.status,
    })).concat(this.$store.state.location.data.blackoutDates.map((d:string) => ({
      start: d, blackout: true, name: 'No R/Os', color: 'black',
    })))
  }

  getEventColor(x:any) {
    if (x.status === 'Approved') return 'green'
    if (x.status === 'Denied') return 'error'
    if (x.name === 'No R/Os') return 'black'
    return 'primary'
  }

  requestTypes = [
    { text: 'Unconfirmed', value: { id: 'unconfirmed', filter: (x:RequestOffType) => x.status === 'Unconfirmed' } },
    { text: 'Approved', value: { id: 'approved', filter: (x:RequestOffType) => x.status === 'Approved' } },
    { text: 'Denied', value: { id: 'denied', filter: (x:RequestOffType) => x.status === 'Denied' } },
    { text: 'All', value: { id: 'all', filter: (x:RequestOffType) => x } },
  ]

  requestDates = 'View Upcoming'

  requestType:any = this.requestTypes[0].value

  notes:string = ''

  mountPreviousRequests() {
    if (this.upcomingRequestsOff !== []) return false
    this.$bind('previousRequestsOff', db.collection('requestsOff').where('location', '==', this.location).where('end', '<', dayjs(new Date()).format('YYYY-MM-DD')).orderBy('end', 'asc'))
    return true
  }

  async updateRequest(status:string) {
    this.loading = true
    if (!this.activeRequest || !this.activeRequest.id) {
      this.loading = false
      return false
    }
    await update(requestsOff, this.activeRequest.id, {
      updated: new Date(), location: this.location, notes: this.notes, status, manager: this.uid,
    })
    this.$toast.success('Success - We Updated The Request')
    this.resetRequest()
    this.notes = ''
    this.loading = false
    return true
  }

  bindMonth(d:Date) {
    this.$bind('visibleRequests', db.collection('requestsOff').where('location', '==', this.location)
      .where('end', '>=', dayjs(d).date(1).format('YYYY-MM-DD'))
      .where('end', '<=', dayjs(d).add(1, 'month').date(15).format('YYYY-MM-DD'))
      .orderBy('end', 'asc'))
  }

  bindRequests(previous:boolean = false) {
    this.$bind('visibleRequests', db.collection('requestsOff').where('location', '==', this.location).where('end', previous ? '<=' : '>=', dayjs().format('YYYY-MM-DD')).orderBy('end', 'asc'))
  }

  mounted() {
    this.bindMonth(new Date())
  }
}

